import { GridColDef } from "@mui/x-data-grid-pro";

// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// Types
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";

const columns: GridColDef[] = [
	{
		field: "_id",
		headerName: "ID",
		flex: 1,
	},
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },

	{
		field: "manuallyReconciled",
		headerName: "",
		editable: true,
	},
	{
		field: "vinNumber",
		headerName: "VIN",
		width: 140,
	},
	{
		field: "year",
		headerName: "Year",
		width: 50,
	},
	{
		field: "_empty",
		headerName: "",
		width: 60,
	},
	{
		field: "make",
		headerName: "Make",
		width: 150,
	},
	{
		field: "model",
		headerName: "Model",
		width: 160,
	},
	{
		field: "color",
		headerName: "Color",
		width: 110,
	},
	{
		field: "reason",
		headerName: "Reason",
		width: 160,
		editable: true,
	},
	{
		field: "resolution",
		headerName: "Resolution",
		width: 160,
		editable: true,
	},
	{
		field: "notes",
		headerName: "Notes",
		headerAlign: "right",
		align: "right",
		width: 80,
		editable: true,
	},
];

type TOnMfgNotOnLotTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

export default function OnMfgNotOnLotTable(props: TOnMfgNotOnLotTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;
	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="onMfgNotOnLot"
		/>
	);
}
